/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** SubscriptionType */
export enum SubscriptionType {
  Free = 'free',
  Advanced = 'advanced',
  Professional = 'professional',
}

/** SubscriptionStatus */
export enum SubscriptionStatus {
  Active = 'active',
  CancellationRequest = 'cancellationRequest',
  Inactive = 'inactive',
}

/** CompanyPortalCustomerSuccessContactDto */
export interface CompanyPortalCustomerSuccessContactDto {
  name: string;
  email?: string;
  phone?: string;
  profilePictureUrl?: string;
  title?: string;
}

/** CompanyPortalOnboardingExperienceDto */
export interface CompanyPortalOnboardingExperienceDto {
  currentlyOnboarding: boolean;
  /** @format date-time */
  onboardingCompletedAt?: string;
  customerSuccessContact?: CompanyPortalCustomerSuccessContactDto;
  categories: CompanyPortalOnboardingTodoCategoryDto[];
}

/** CompanyPortalOnboardingTodoCategoryDto */
export interface CompanyPortalOnboardingTodoCategoryDto {
  id: string;
  title: string;
  /** @format int32 */
  sortOrder: number;
  items: CompanyPortalOnboardingTodoItemDto[];
}

/** CompanyPortalOnboardingTodoItemDto */
export interface CompanyPortalOnboardingTodoItemDto {
  id: string;
  title: string;
  description?: string;
  /** @format int32 */
  sortOrder: number;
  links: string[];
  done: boolean;
  /** @format date-time */
  addedAt: string;
  /** @format date-time */
  completedAt?: string;
}

/** EffectiveCompanySubscriptionDto */
export interface EffectiveCompanySubscriptionDto {
  subscriptionPlanKey: string;
  subscriptionType: SubscriptionType;
  planVersion: string;
  status: SubscriptionStatus;
  hasContract: boolean;
  /** @format date */
  contractEndDate?: string;
  cancelAtContractEnd: boolean;
  /** @format double */
  saasFeePerUnit: number;
  /** @format double */
  fixedSaasPrice?: number;
  /** @format double */
  tenantTransactionFee: number;
  /** @format double */
  outgoingAchFee: number;
  /** @format double */
  achReturnFee: number;
  /** @format double */
  creditCardDisputeFee: number;
  /** @format int32 */
  minimumSubscriptionLeases: number;
  /** @format int32 */
  maximumLease?: number;
  /** @format int32 */
  minimumDaysBetweenSweeps: number;
  /** @format double */
  maximumSingleTenantTransactionAmount?: number;
  /** @format double */
  maximumTenantPaymentsVolume?: number;
  /** @format double */
  maximumOutgoingAchTransactionAmount?: number;
  /** @format double */
  maximumOutgoingAchTransactionTotalVolume?: number;
  allowCreditCard: boolean;
  allowAch: boolean;
  allowZelle: boolean;
  /**
   * Legacy credit card fee percent used for Stripe.
   * @format double
   */
  creditCardFeePercent: number;
  /**
   * New payments service: consumer credit (V/MC/Disc) fee rate (e.g. 0.0335 = 3.35%).
   * @format double
   */
  cardProcessingCreditPercent: number;
  /**
   * New payments service: consumer credit (V/MC/Disc) flat fee per transaction in dollars.
   * @format double
   */
  cardProcessingCreditFixedAmount: number;
  /**
   * New payments service: Amex consumer credit fee rate (e.g. 0.0385 = 3.85%).
   * @format double
   */
  cardProcessingAmexCreditPercent: number;
  /**
   * New payments service: Amex consumer credit flat fee per transaction in dollars.
   * @format double
   */
  cardProcessingAmexCreditFixedAmount: number;
  /**
   * New payments service: business/commercial credit fee rate (e.g. 0.0425 = 4.25%).
   * @format double
   */
  cardProcessingBusinessCreditPercent: number;
  /**
   * New payments service: business/commercial credit flat fee per transaction in dollars.
   * @format double
   */
  cardProcessingBusinessCreditFixedAmount: number;
  /**
   * New payments service: regulated consumer debit fee rate (e.g. 0.019 = 1.9%).
   * @format double
   */
  cardProcessingDebitPercent: number;
  /**
   * New payments service: regulated consumer debit flat fee per transaction in dollars.
   * @format double
   */
  cardProcessingDebitFixedAmount: number;
  /**
   * New payments service: exempt or unknown consumer debit fee rate (e.g. 0.0295 = 2.95%).
   * @format double
   */
  cardProcessingExemptDebitPercent: number;
  /**
   * New payments service: exempt or unknown consumer debit flat fee per transaction in dollars.
   * @format double
   */
  cardProcessingExemptDebitFixedAmount: number;
  /**
   * New payments service: business/commercial debit fee rate (e.g. 0.0315 = 3.15%).
   * @format double
   */
  cardProcessingBusinessDebitPercent: number;
  /**
   * New payments service: business/commercial debit flat fee per transaction in dollars.
   * @format double
   */
  cardProcessingBusinessDebitFixedAmount: number;
  /** @format double */
  zellePaymentFee: number;
  allowConvenienceFees: boolean;
  allowCustomDomains: boolean;
  globalAiEnabled: boolean;
  liveSupportEnabled: boolean;
  ticketSupportEnabled: boolean;
  /** @format int32 */
  websiteMaxCustomPages?: number;
  enableAiRunbooks: boolean;
  /** @format double */
  monthlyTcrFee: number;
  /** @format double */
  tcrRegistrationFee: number;
  /** @format double */
  textingCostPerMessage: number;
  /** @format double */
  transunionCreditReportFee: number;
  /** @format double */
  transunionCriminalReportFee: number;
  /** @format double */
  transunionEvictionsReportFee: number;
  /** @format int32 */
  supportHoursPerMonth: number;
  /** @format double */
  damageWaiverCost: number;
  residentBenefitBundleCosts: Record<string, number>;
  /**
   * Monthly fee per active PlaidConnection (Plaid Item). Charged on the 1st for all Active connections.
   * @format double
   */
  bankFeedMonthlyFee: number;
  /**
   * Per-request fee for manual bank feed refresh beyond the free monthly quota.
   * @format double
   */
  bankFeedManualRefreshFee: number;
  /**
   * Free manual bank feed refreshes per company per month.
   * @format int32
   */
  bankFeedFreeRefreshQuota: number;
}
